interface ManageMonitoringStopConfirmProps {
    onCancel: () => void;
    onConfirm: () => void;
    isLoading: boolean;
}

function ManageMonitoringStopConfirm({
    onCancel,
    onConfirm,
    isLoading
}: ManageMonitoringStopConfirmProps) {
    return (
        <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-red-200 bg-red-50 px-3.5 py-3">
                <h3 className="text-sm font-semibold text-red-700">Stop monitoring?</h3>
                <p className="text-sm text-red-700/80 mt-1 leading-relaxed">
                    Stopping ends the monitoring plan. The patient will stop receiving scan
                    reminders and no new scans will arrive. This can&apos;t be undone from here.
                </p>
            </div>

            <div className="flex justify-end items-center gap-3">
                <button
                    type="button"
                    onClick={onCancel}
                    disabled={isLoading}
                    className="bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={isLoading}
                    className="px-4 py-2 text-sm font-semibold text-white bg-red-600 rounded-lg shadow hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                    {isLoading && (
                        <div className="h-3.5 w-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    )}
                    Stop monitoring
                </button>
            </div>
        </div>
    );
}

export { ManageMonitoringStopConfirm };
